/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';

export const utilities = (state = defaultState.utilities, action) => {
    let nextState = Utilities.deepClone(state);

    if (action.status === constants.STATE_TXRX) {
        // reset url info object when we start transmitting
        if (action.type === constants.UTILITIES_URL_INFO_FETCH) {
            nextState.urlInfo = {};
        }
    }

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.UTILITIES_FETCH_TIMEZONES:
                nextState.timezones = action.payload;
                break;

            case constants.UTILITIES_URL_INFO_FETCH:
                nextState.urlInfo = action.payload;
                break;

            case constants.UTILITIES_FETCH_COUNTRIES:
                nextState.countries = action.payload;
                break;

            case constants.UTILITIES_FETCH_REGIONS:
                nextState.regions = action.payload;
                break;

            case constants.UTILITIES_FETCH_FAVORITES:
                nextState.favorites = action.payload;
                break;

            case constants.UTILITIES_FETCH_RELATED_HASHTAGS:
                nextState.relatedTags = action.payload;
                break;

            default:
                break;
        }
    }

    if (action.type === constants.UTILITIES_CLEAR_RELATED_HASHTAGS) {
        nextState.relatedTags = [];
    }

    if (action.type === constants.UTILITIES_URL_INFO_CLEAR) {
        nextState.urlInfo = {};
    }

    return nextState;
};
